class DetailsDropdown extends HTMLElement {
    constructor() {
        super();
        this._detailsDropdown = this.querySelector('[detailsDropdown]');
        this._detailsSummary = this.querySelector('[detailsDropdown] summary');
        this._detailsBody = this.querySelector('[detailsBody]');
        this._animatinItems = this.querySelector('[animation-item]');
        this._animationType = this.querySelector('[animation-type]').getAttribute('animation-type') || 'fade-down';


        this._debouncedOpenDropdown = HELPER_UTIL.debounce(this.opendDropdown.bind(this), 150);
        this._debouncedCloseDropdown = HELPER_UTIL.debounce(this.closeDropdown.bind(this), 150);

        this._detailsDropdown.addEventListener(
            'mouseenter',
            this._debouncedOpenDropdown
        );
        this._detailsDropdown.addEventListener(
            'mouseleave',
            this._debouncedCloseDropdown
        );

        // If the detailsDropdown element has the 'open' attribute, open it by default
        if (this._detailsDropdown.hasAttribute('open')) {
            this.activeDetailsDropdown();
        }

        // Handle mobile touch: open on touch, close others
        if (window.matchMedia("(max-width: 991px)").matches) {
            // On touchstart, open this dropdown and close others
            this._detailsSummary.addEventListener('touchstart', (e) => {
                // Prevent default to avoid click event
                e.preventDefault();
                e.stopPropagation();

                // Close all other open dropdowns
                document.querySelectorAll('details-dropdown').forEach((el) => {
                    if (el !== this && el._detailsDropdown && el._detailsDropdown.hasAttribute('open')) {
                        el.inActiveDetailsDropdown(el._detailsBody, el._detailsDropdown);
                    }
                });

                // Open this dropdown if not already open
                if (!this._detailsDropdown.hasAttribute('open')) {
                    this.activeDetailsDropdown();
                } else {
                    // If already open, close it
                    this.inActiveDetailsDropdown(this._detailsBody, this._detailsDropdown);
                }
            });

        }
    }

    animateDetailsDropdownOnOpen() {
        if (this._animationType === "fade-up") {
            Motion.animate(this._animatinItems, { opacity: [0, 1], y: [20, 0] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" })
        } else {
            Motion.animate(this._animatinItems, { opacity: [0, 1], y: [-20, 0] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" })

        }
    }

    animateDetailsDropdownOnClose(dropdownBody, dropdownDetails) {
        const animationItem = dropdownBody.querySelector('[animation-item]')
        const animationType = dropdownDetails.querySelector('[animation-type]').getAttribute('animation-type') || 'fade-down'
        if (animationType === "fade-up") {
            Motion.animate(animationItem, { opacity: [1, 0], y: [0, 20] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" }).finished.then(() => {
                dropdownDetails.removeAttribute("open")
            })
        } else {
            Motion.animate(animationItem, { opacity: [1, 0], y: [0, -20] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" }).finished.then(() => {
                dropdownDetails.removeAttribute("open")
            })
        }

    }

    inActiveDetailsDropdown(dropdownBody, dropdownDetails) {
        dropdownBody.classList.remove('active');
        dropdownDetails.setAttribute("aria-expanded", "false")
        // this._detailsDropdown.style.height = `${ this._detailsDropdown.querySelector('summary').offsetHeight }` + 'px';
        this.animateDetailsDropdownOnClose(dropdownBody, dropdownDetails)
    }

    activeDetailsDropdown() {
        this._detailsBody.classList.add('active');
        this._detailsDropdown.setAttribute("open", "true")
        this._detailsDropdown.setAttribute("aria-expanded", "true")
        // this._detailsDropdown.style.height = `${ this._detailsDropdown.querySelector('summary').offsetHeight + this._detailsBody.offsetHeight}` + 'px';
        window.requestAnimationFrame(() => {
            this.animateDetailsDropdownOnOpen()
        })
    }



    opendDropdown(e) {

        e.preventDefault();
        if (this._detailsBody.classList.contains('active')) return
        this._detailsDropdown.classList.add('active');

        this._allDropdowns = document.querySelectorAll('[detailsDropdown][open="true"]');
        this._allDropdowns && this._allDropdowns.forEach((dropdown) => {
            const dropdownBody = dropdown.querySelector('[detailsBody]')
            const dropdownDetails = dropdown
            this.inActiveDetailsDropdown(dropdownBody, dropdownDetails)
        }
        )
        this.activeDetailsDropdown();
    }

    closeDropdown(e) {
        e.preventDefault();
        if (this._detailsBody.classList.contains('active')) {
            this.inActiveDetailsDropdown(this._detailsBody, this._detailsDropdown);
            this._detailsDropdown.classList.remove('active');
        }
    }
    connectedCallback() {
        // this._detailsDropdown.style.height = `${ this._detailsDropdown.querySelector('summary').offsetHeight }` + 'px';
    }
}

customElements.define('details-dropdown', DetailsDropdown);

/* ===== Apex megamenu sticky-panel patch (v9) ===== */
/* Apex megamenu sticky-panel patch v9.
   Every close of a top nav menu funnels through HeaderMenuTrigger._hideDropDown
   (mouseleave timer, HeaderComponent's scroll listener, outside click, sibling
   switch). For the five custom megamenus only, gate that one function: defer
   the close while the page is scrolling or while the browser still reports
   this menu as hovered; run it once scrolling has stopped AND hover is gone.
   Hover uses the browser's own :hover state (ground truth for a real mouse),
   with elementFromPoint as a fallback. */
(function () {
  if (window.__apexMegaSticky) return;
  window.__apexMegaSticky = true;
  if (!window.matchMedia || !window.matchMedia('(min-width: 992px)').matches) return;

  var lastX = -1, lastY = -1, lastScroll = 0;
  document.addEventListener('pointermove', function (e) { lastX = e.clientX; lastY = e.clientY; }, { passive: true });
  window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true, capture: true });

  function pointerInside(el) {
    try { if (el.matches(':hover')) return true; } catch (e) {}
    if (lastX < 0) return false;
    var t = document.elementFromPoint(lastX, lastY);
    return !!(t && el.contains(t));
  }

  function patch(el) {
    if (el.__apexPatched) return;
    var orig = el._hideDropDown;
    if (typeof orig !== 'function') return;
    el.__apexPatched = true;
    var timer = null;
    el._hideDropDown = function () {
      var self = this, args = arguments;
      function attempt() {
        if (Date.now() - lastScroll < 500 || pointerInside(el)) {
          clearTimeout(timer);
          timer = setTimeout(attempt, 300);
          return;
        }
        orig.apply(self, args);
      }
      attempt();
    };
  }

  function init() {
    document.querySelectorAll('header-menu-trigger[data-identefier="parent-element"]').forEach(function (el) {
      if (el.querySelector('.apex-mm')) patch(el);
    });
  }

  function ready() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('header-menu-trigger').then(function () { setTimeout(init, 60); });
    } else {
      setTimeout(init, 300);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
